import React from 'react'

import { StyledContainer } from './styled'
import ArticlePreview from '../ArticlePreview'
import { Article } from '../ArticlePreview/ArticlePreview'

interface ArticlesProps {
  articles: Article[]
}

const Articles: React.FC<ArticlesProps> = ({ articles }) => {
  return (
    <StyledContainer medium>
      {articles.map((article) => (
        <ArticlePreview key={article.slug} article={article} />
      ))}
    </StyledContainer>
  )
}

export default Articles
